import { atom } from "jotai";

export const authTokenAtom = atom(localStorage.getItem("auth_token") || null);
